import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { getActiveUpload } from '../services/uploadService';
import { useAuth } from './AuthContext';

const ActiveUploadContext = createContext(null);

export function ActiveUploadProvider({ children }) {
  const { user } = useAuth();
  const [activeUpload, setActiveUpload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  async function refreshActiveUpload() {
    if (!user) return;
    setLoading(true);
    setError('');
    try {
      const upload = await getActiveUpload();
      setActiveUpload(upload);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    refreshActiveUpload();
  }, [user?.id]);

  const value = useMemo(() => ({ activeUpload, loading, error, refreshActiveUpload }), [activeUpload, loading, error]);
  return <ActiveUploadContext.Provider value={value}>{children}</ActiveUploadContext.Provider>;
}

export function useActiveUpload() {
  const value = useContext(ActiveUploadContext);
  if (!value) throw new Error('useActiveUpload must be used inside ActiveUploadProvider');
  return value;
}
